import { PostTypeSeo } from "graphql";
import { NextSeo } from "next-seo";

export interface SEOProps {
  seo?: PostTypeSeo;
}

const SEO = ({ seo }: SEOProps) => {
  const { title, metaDesc } = seo || {};
  return (
    <NextSeo
      title={title ?? `Beyer Cares Foundation`}
      description={metaDesc ?? `Beyer Cares Foundation`}
    />
  );
};

export default SEO;
